import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import CertificateEntry from './CertificateEntry';
import {getCertificate, selectCertificate} from '../certificate';
import {FormattedMessage} from "react-intl";
import styles from "./css/Certificate.scss";

export class CertificateEntries extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        session: ImmutablePropTypes.map.isRequired,
        certificate: ImmutablePropTypes.map
    };

    componentWillMount() {
        window.scrollTo(0, 0 );
        this.props.dispatch(getCertificate());
    }

    render() {
        const {session, certificate} = this.props;
        const userData = session.get('user');

        if (!certificate || certificate.size === 0 || (typeof certificate === 'object' && Object.keys(certificate).size === 0)) {
            return (
                <div className={styles.entry}>
                    <FormattedMessage id='frontend.certificate.text.empty' />
                </div>
            );
        }

        return (
            <div>
                {certificate ?
                    certificate.map(entry => {
                        return (
                            <CertificateEntry user={userData} entry={entry} key={entry.getIn(['location', 'id'])}/>
                        );}).toArray()
                    : null}
            </div>
        );
    }
}

export default connect(state => ({
    session: state.session,
    dispatch: state.dispatch,
    certificate: selectCertificate(state),
}))(CertificateEntries);
